import { render } from "./DateInfo.vue?vue&type=template&id=2e8c01d1"
import script from "./DateInfo.vue?vue&type=script&lang=js"
export * from "./DateInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__